export default __webpack_public_path__ + "static/media/amrit-gurantee.72efa082.png";